import { createSvgComponent } from "../../icon/createSvgComponent";
import Setting from "@core/__generated__/icon/figma/setting.svg";
export default createSvgComponent(Setting);